import {
    ConfirmRemoveParticipantDialog,
    selectLessonId,
    useCallAdapter,
    usePcpApiMethods,
    usePcpLiveLessonContext,
} from "live-lesson/shared/feature-call-ui-react";
import React, { useCallback, useMemo, useState } from "react";

/**
 * Moderator removes participant (student) from the call:
 * - immediately using the CallAdapter
 * - deferred using the PCP Api
 *
 * NOTE: when removing using the PCP API, the student gets removes from the call permanently.
 */
export const useRemoveParticipantFromCall = () => {
    const api = usePcpApiMethods();
    const callAdapter = useCallAdapter();

    const [showConfirmDialog, setShowConfirmDialog] = useState(false);
    const [remoteParticipantId, setRemoteParticipantId] = useState<string | null>(null);

    const removeParticipantWithConfirmCallback = useCallback((participantId: string) => {
        setRemoteParticipantId(participantId);
        setShowConfirmDialog(true);
    }, []);

    const confirmRemoveParticipantDialog = useMemo(() => {
        if (!remoteParticipantId) {
            return null;
        }

        return (
            <ConfirmRemoveParticipantDialog
                open={showConfirmDialog}
                onClose={() => setShowConfirmDialog(false)}
                onConfirm={() => removeParticipantCallback(remoteParticipantId)}
            />
        );
    }, [showConfirmDialog, remoteParticipantId]);


    const lessonId = usePcpLiveLessonContext(selectLessonId);


    const removeParticipantCallback = useCallback((participantId: string) => {
        setRemoteParticipantId(null);
        setShowConfirmDialog(false);

        callAdapter.removeParticipant(participantId).catch(console.error);
        const makeRequest = async () => {
            const response = await api.removeParticipant(lessonId, participantId);
        };
        makeRequest().catch(console.error);
    }, [lessonId]);

    return {
        removeParticipantCallback,
        removeParticipantWithConfirmCallback,
        confirmRemoveParticipantDialog,
    }
};
